import { observer } from 'mobx-react';

import { Loader } from '../../../../components/Loader/Loader';
import { useStores } from '../../../../stores/useStores';
import { CROWN_RIPS_WIDGET_IMAGE } from '../../constants/widget-images.constants';
import type { CrownRipsWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralSmallWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

interface CrownRipsWidgetProps {
  sizeType: WidgetSizeType;
  data: CrownRipsWidgetDataType;
}

function CrownRipsWidgetComponent({ data }: CrownRipsWidgetProps) {
  const { crownRipsStore } = useStores();

  // Launch does an async resolve + launch-game round-trip before the game-ui dialog opens; show a
  // full-screen loader for that gap so the tap has immediate feedback (and can't be double-fired).
  const onClick = () => {
    if (crownRipsStore.isLoadingGame) return;
    void crownRipsStore.startCrownRipsGame();
  };

  return (
    <>
      {/* Badge-only: a small square, clickable badge (branding lives in the round image itself — no CTA
          or title). Forced to the 'small' size so it matches the neighbouring game badges rather than
          stretching into a wide slot. */}
      <WidgetWrapper dataTestId={data.dataTestId} sizeType="small" onClick={onClick}>
        <GeneralSmallWidget widgetImageUrl={CROWN_RIPS_WIDGET_IMAGE} />
      </WidgetWrapper>
      {crownRipsStore.isLoadingGame && <Loader fullScreen />}
    </>
  );
}

export const CrownRipsWidget = observer(CrownRipsWidgetComponent);
